import utils from 'utils'
import globalFnFactory from 'components/globalFn/globalFnFactory'
const globalFn = globalFnFactory()

class orgDetailCtrl {
    constructor($scope, httpRequest, $stateParams, $state, sweetalert, logger, Upload, $rootScope, operationService) {
        $scope.orgId = $stateParams.orgId
        const user_info = JSON.parse(localStorage.getItem('user_info'))
        $state.current.url == '/info' && ($scope.isCompany = true)
        const httpAPI = $scope.isCompany ? 'post_getTenantDetail' : 'post_qryOrgDetail'
        httpRequest.get_dictByTypeArr('["taxplayer_type","ivat_common_flag","industry_classification","accounting_system","register_type"]').then((res) => {
            $scope.dictData = $.extend({}, res.data.value)
            $scope.dictData.taxplayer_type = $scope.dictData.taxplayer_type.filter((x) => {
                return x.enumName == '一般纳税人' || x.enumName == '小规模纳税人'
            })
            //企业类型//$scope.registeraS2 = {}
            $scope.registerOptions = $.extend(
                {
                    placeholder: '请选择',
                },
                {
                    data: toSelect2data($scope.dictData.register_type),
                }
            )

            //所属行业//$scope.industryaS2 = {}
            $scope.industryOptions = $.extend(
                {
                    placeholder: '请选择',
                },
                {
                    data: toSelect2data($scope.dictData.industry_classification),
                }
            )
            //会计制度//$scope.accountingaS2 = {}
            $scope.accountingOptions = $.extend(
                {
                    placeholder: '请选择',
                },
                {
                    data: toSelect2data($scope.dictData.accounting_system),
                }
            )
        })

        function init() {
            let param = {
                detailOrgId: $scope.orgId,
            }
            httpRequest[httpAPI](param).then((res) => {
                $scope.detialForm = res.data.value.org
                if ($scope.isCompany && localStorage.deployType == 2) {
                    $scope.canUpload = true
                    $scope.current.imageContent = $scope.detialForm.imageContent || localStorage.defaultLogo
                }
                $scope.packList = res.data.value.packList
            })
        }
        if ($scope.orgId) {
            init()
        } else {
            //当所有机构都禁用 显示parentorgid = -1
            $scope.queryParam = {
                pageNum: 1,
                pageSize: 10,
                param: {
                    parentOrgCode: -1,
                },
            }
            httpRequest.post_organizationList($scope.queryParam).then((res) => {
                const listData = res.data.value.list
                $scope.orgId = listData[0].orgId
                if (!$scope.orgId) {
                    const org = user_info.org || user_info.orgList[0]
                    $scope.orgId = org && org.orgId
                }
                init()
            })
        }

        $scope.beforeUpload = function beforeUpload(e) {
            e.preventDefault()
            sweetalert.confirm('操作提醒', '您已成功导入license授权，请确认是否要重新导入license授权').then(() => {
                $('#license-upload-btn').trigger('click')
            })
        }

        $scope.uploadFiles = function uploadFiles(file, errFiles) {
            utils.loading('license导入中')
            $scope.f = file
            $scope.errFile = errFiles && errFiles[0]
            if (file) {
                file.upload = Upload.upload({
                    url: `${host.etcloud}settings/sysOwnerInfo/importClientLic`,
                    data: {
                        licenseFile: file,
                        // name:$scope.clientLicFile
                    },
                })

                file.upload
                    .then(
                        (response) => {
                            // $timeout(() => {
                            file.result = response.data
                            if (file.result.success) {
                                // if (file.result.message == null) file.result.message = '导入license成功'
                                logger.logSuccess('您已成功导入license授权，请重新登陆后使用相关的功能!')
                                localStorage.removeItem('id_token')
                                localStorage.removeItem('user_info')
                                //localStorage.removeItem('function_tree')
                                $rootScope.userInfo = null
                                $rootScope.userMessage = {
                                    userNoticeList: null,
                                    taskTotalCount: 0,
                                    userNoticeCount: 0,
                                }
                                operationService.destroy()
                                $scope.$emit('logoChange')
                                $state.go('login')
                                setTimeout(() => {
                                    window.layer.closeAll()
                                }, 1500)
                            } else {
                                logger.logError(file.result.message)
                            }
                            // })
                        },
                        (response) => {
                            logger.logError(response.data.message)
                        },
                        (evt) => {
                            file.progress = Math.min(100, parseInt((100.0 * evt.loaded) / evt.total, 10))
                        }
                    )
                    .finally(() => {
                        utils.loaded()
                    })
            }
        }

        $scope.editBaseInfo = () => {
            $scope.isEdit = true
        }

        $scope.upload = function upload(file, invalid) {
            if (file == null) {
                // 不符合文件格式的错误提示
                if (invalid.length >= 1) {
                    logger.logError('建议上传图片尺寸为147*45px，大小不超过1M，支持jpg、png、gif格式')
                }
            } else {
                const fileReader = new FileReader()
                fileReader.onload = function onload(e) {
                    $scope.detialForm.imageContent = e.target.result
                }
                fileReader.readAsDataURL(file)
            }
        }
        $scope.cancel = () => {
            $scope.isEdit = false
            $scope.current.file = ''
            $scope.detialForm.imageContent = $scope.current.imageContent
            init()
        }
        $scope.ok = () => {
            $scope.detialForm.imageContent || ($scope.detialForm.imageContent = $scope.current.imageContent)
            const result = editCheck($scope.detialForm)
            if (result == 'success') {
                utils.loading('企业信息保存中')
                $scope.detialForm.saleInfo.saleName = $scope.detialForm.orgName
                httpRequest
                    .post_companyInfo($scope.detialForm, '企业信息更新成功！')
                    .then(() => {
                        $scope.isEdit = false
                        $scope.$emit('logoChange')
                        init()
                    })
                    .finally(() => {
                        utils.loaded()
                    })
            } else {
                logger.logError(result)
            }
            console.log($scope.detialForm)
        }
        $scope.current = {}

        function editCheck(obj) {
            if (obj.orgName.toString().length < 2 || obj.orgName.toString().length > 100) return '企业名称，最少2位字符,最多100位字符'

            if (!globalFn.checkTax(obj.saleInfo.saleCreditCode)) return '纳税人识别号必须为15位、17位、18位、20位或21位'

            if (!obj.saleInfo.taxplayerType) return '纳税人类型不能为空'

            if (!obj.saleInfo.companyProperty) return '退税企业不能为空'

            if (obj.email && !utils.regExpTest(obj.email, 'email')) return '联系人邮箱格式不正确'

            return 'success'
        }

        function toSelect2data(list) {
            const result = []
            for (const a in list) {
                const tempdata = {
                    id: '',
                    text: '',
                }
                $.extend(tempdata, list[a])
                tempdata.id = list[a]['enumCode']
                tempdata.text = list[a]['enumName']
                result.push(tempdata)
            }
            return result
        }
    }
}

orgDetailCtrl.$inject = ['$scope', 'httpRequest', '$stateParams', '$state', 'sweetalert', 'logger', 'Upload', '$rootScope', 'operationService']
export default orgDetailCtrl



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/org/orgDetailCtrl.js